import "./HSSStructuralProducts.module.css";
import Header from "@/reusable_sections/Header";
import ProductosEstructurales from "./sections/ProductosEstructurales";
import Footer from "@/reusable_sections/Footer";
export default function HSSStructuralProductsPage() {
  return <div>
      <Header />
      <ProductosEstructurales />
      <Footer />
    </div>;
}